import { fetchMarketData as rawFetchMarketData } from './index';

const marketDataCache = new Map();

/**
  * Wrapper to fetch market data for an instrument token.
  * Handles mapping the input exchange into exchange/segment path parts
  * and deduplicates concurrent duplicate requests (e.g. in React StrictMode).
  */
export function fetchMarketData(exchange, token) {
  const segments = { 
    NSE: "NSE/Capital", 
    BSE: "BSE/Capital", 
    NFO: "NSE/FutOpt", 
    BFO: "BSE/FutOpt", 
    CDS: "NSE/Currency", 
    MCX: "MCX/FutOpt" 
  };
  
  const mapped = segments[exchange] || `${exchange}/FutOpt`;
  const [exchangePath, segmentPath] = mapped.split('/');
  const cacheKey = `${exchangePath}/${segmentPath}/${token}`;

  if (!marketDataCache.has(cacheKey)) {
    const promise = rawFetchMarketData(exchangePath, segmentPath, token);
    // Delete from cache after 1 second to ensure subsequent refreshes/user clicks get fresh data
    promise.finally(() => setTimeout(() => marketDataCache.delete(cacheKey), 1000));
    marketDataCache.set(cacheKey, promise);
  }
  
  return marketDataCache.get(cacheKey);
}
